/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seed_TypeInputs */

const en_seed_type = /** @type {(inputs: Seed_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seed type`)
};

const th_seed_type = /** @type {(inputs: Seed_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประเภทเมล็ดพันธุ์`)
};

const ja_seed_type = /** @type {(inputs: Seed_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シードタイプ`)
};

const fr_seed_type = /** @type {(inputs: Seed_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de graine`)
};

const es_seed_type = /** @type {(inputs: Seed_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de semilla`)
};

const ru_seed_type = /** @type {(inputs: Seed_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип семян`)
};

const zh_seed_type = /** @type {(inputs: Seed_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`种子类型`)
};

const vi_seed_type = /** @type {(inputs: Seed_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại hạt giống`)
};

/**
* | output |
* | --- |
* | "Seed type" |
*
* @param {Seed_TypeInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const seed_type = /** @type {((inputs?: Seed_TypeInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seed_TypeInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_seed_type(inputs)
	if (locale === "ja") return ja_seed_type(inputs)
	if (locale === "fr") return fr_seed_type(inputs)
	if (locale === "es") return es_seed_type(inputs)
	if (locale === "ru") return ru_seed_type(inputs)
	if (locale === "zh") return zh_seed_type(inputs)
	if (locale === "vi") return vi_seed_type(inputs)
	return en_seed_type(inputs)
});